import { CalendarClock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

// Renders a past-date picker only while the admin has Backdated entry mode ON.
// Otherwise renders nothing and records fall back to today's date server-side.
export const BackdateField = ({ value, onChange, className = "" }) => {
  const { user } = useAuth();
  if (!user?.backdate_mode) return null;
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div
      className={`w-full rounded-md border border-amber-300 bg-amber-50 p-3 ${className}`}
      data-testid="backdate-field"
    >
      <Label className="flex items-center gap-1.5 text-xs font-semibold text-amber-800">
        <CalendarClock className="h-3.5 w-3.5" /> Historical entry date
      </Label>
      <Input
        type="date"
        max={today}
        className="mt-1.5 min-h-[44px] bg-white"
        data-testid="backdate-date-input"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="mt-1 text-[11px] leading-snug text-amber-700">
        Saved with this past date and kept out of the current month's figures. Leave blank to use today.
      </p>
    </div>
  );
};
